export default "__VITE_ASSET__BJInGThw__";